<template>
  <div class="research_group_container" style="background-color: rgba(250, 250, 250, 1);">
    <!-- <base-header :headerName="headerName" @goBack="goBack" /> -->
    <div class="page-progress flex-col">
      <div class="flex-col justify-between">
        <div class="mod4 flex-col">
          <div class="bd1 flex-col">
            <experiment-header :contractNo='contractProgressInfo.contractNo' :status="contractProgressInfo.status"/>
            <div style="margin-top: 15px;">
              <div
                v-for="(progress, index) in contractProgressInfo.progressNotes"
                :key="index"
                class="historyProgress"
              >
                <div class="box4 flex-row justify-between">
                  <img
                    v-if="index === 0"
                    class="label1"
                    referrerpolicy="no-referrer"
                    src="/static/img/最新进展.svg"
                  />
                  <div v-else class="bd3 flex-col"></div>
                  <span class="info4" v-if="index === 0"
                    >{{ progress.createDT }}&nbsp;最新进展：</span
                  >
                  <span class="txt4" v-else>{{ progress.createDT }}</span>
                  <div class="main1 flex-col" v-if="index === 0" style="margin-left:13px"></div>
                </div>
                <div class="progress">
                  <div
                    class="group_history flex-col"
                    v-if="index !== contractProgressInfo.progressNotes.length - 1"
                  ></div>
                  <div
                    class="paragraph1"
                    :class="{
                      'paragraph-font1': index !== 0,
                      'paragraph-font2': index === 0,
                    }"
                    :style="{
                      'margin-left':
                        index === contractProgressInfo.progressNotes.length - 1 ? '20px' : '10px',
                    }"
                  >
                    <!-- <span
                      v-for="(item, index) in progress.list"
                      :key="index"
                      style="margin-top: 5px"
                    >
                      {{ index + 1 }}.&nbsp; {{ item }}
                      <br />
                    </span> -->
                     <span
                      style="margin-top: 5px"
                    >
                      1.&nbsp; {{ progress.content }}
                      <br />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/common.css'
import { mapGetters } from 'vuex'
// import BaseHeader from '@/views_v_2.6/components/BaseHeader'
import ExperimentHeader from '@/views/serviceProgressRefactor/components/ExperimentHeader.vue'
export default {
  data () {
    return {
      headerName: '历史详情',
      contractProgressInfo: null
    }
  },
  components: {
    // BaseHeader,
    ExperimentHeader
  },
  created () {
    this.contractProgressInfo = this.$route.params
  },
  computed: {
    ...mapGetters([
      // 'progressInfo'
      'isWapp'
    ])
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
  .research_group_container {
    overflow-y:scroll;
    overflow-x:hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height:100vh;
  }
  .research_group_container {
    overflow-y:scroll;
    overflow-x:hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height:100vh;
  }
  .historyProgress{
    margin-right: 10px;
  }



  body * {

    flex-shrink: 0;
  }

  .progress{
    display: flex;
    margin-left: 20px;

  }
  .page-progress {
    position: relative;
    /* background-color: rgba(250, 250, 250, 1); */
    background: #FAFAFA;
    overflow: hidden;
    width: 100vw;
    top:1vw;
    /* top: 14.93vw; */
    bottom: 4vw;
    margin-bottom: 10px;
  }



  .mod4 {
    z-index: 2;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    position: relative;
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .box4 {
    width: 38px;
    height: 17px;
    margin-left: 20px;
  }

  .label1 {
    width: 17px;
    height: 17px;
    margin-left: -1px;
  }

  .main1 {
    width: 25px;
    height: 11px;
    background: url(/static/img/最新.svg)
    100% no-repeat;
    margin-top: 3px;
  }









  .paragraph1 {
    margin-left: 10px;
    display: block;
    margin-bottom: 12px;
    margin-top: 12px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: normal;
    flex-shrink: initial !important;
  }
  .paragraph-font1{
    overflow-wrap: break-word;
    color: rgba(151, 151, 151, 1);
    font-size: 12px;
    line-height: 17px;
  }
  .paragraph-font2{
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 12px;
    line-height: 20px;
  }
  .group_history {
    width: 1px;
    background: url(/static/img/SketchPng79a2f345adb4354f7c6e9d905063de31ee490088ce02d9f2e4c56894f82751d8.png)
    100% no-repeat;
    margin-left: 5px;
    margin-right: 5px;
  }










  .txt4 {
    width: 168px;
    height: 17px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(151, 151, 151, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 17px;
    text-align: left;
    margin-left: 10px;
  }

  .info4 {
    width: 168px;
    height: 17px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 12px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 17px;
    text-align: left;
    margin-left: 10px;
  }

  .bd3 {
    width: 11px;
    height: 11px;
    background-color: rgba(151, 151, 151, 1);
    border-radius: 50%;
    margin-top: 2px;
  }






</style>



// WEBPACK FOOTER //
// index.vue?22a393d1